// import {lazy} from 'react'

import AsyncComponent from "@/utils/asyncComponent.jsx";
import { messagePushTemplete } from "./message-push-templete";

const AsyncImport = (pageStr) => {
    /**
     * webpackChunkName 根据后面的变量引入失效，先这样按照hash打包输出
     */
    return AsyncComponent(
        () => import(/* webpackChunkName: "[request]" */ `@/pages/${pageStr}`),
    );
};
const routes = [
    {
        path: "/",
        component: AsyncImport("Home.jsx"),
        pathName: "首页",
        exact: true,
    },
    // {
    //     path: "/report",
    //     component: AsyncImport("year-report"),
    //     pathName: "年度报告",
    // },
    {
        path: "/drive-report",
        component: AsyncImport("drive-report"),
        pathName: "车机周报",
    },
    {
        path: "/disclaimer",
        component: AsyncImport("disclaimer"),
        pathName: "app协议",
    },
    {
        path: "/functionMap/newFrameworkModel/home",
        component: AsyncImport("function-map/new-framework-model"),
        pathName: "新架构车型功能地图主页",
    },
    {
        path: "/functionMap/newFrameworkModel/weekport",
        component: AsyncImport("function-map/new-framework-model/weekport"),
        pathName: "新架构车型功能地图周报",
    },
    {
        path: "/functionMap/withBlindBox/home",
        component: AsyncImport("function-map/with-blind-box"),
        pathName: "C10二期带盲盒功能地图",
    },
    {
        path: "/functionMap/withBlindBox/weekport",
        component: AsyncImport("function-map/with-blind-box/weekport"),
        pathName: "C10二期功能地图周报",
    },
    {
        path: "/functionMap/newCarModel/home",
        component: AsyncImport("function-map/new-car-model"),
        pathName: "C10功能地图",
    },
    {
        path: "/functionMap/newCarModel/weekport",
        component: AsyncImport("function-map/new-car-model/weekport"),
        pathName: "C10功能地图周报",
    },
    {
        path: "/functionMap/home",
        component: AsyncImport("function-map"),
        pathName: "功能地图",
    },
    {
        path: "/functionMap/weekport",
        component: AsyncImport("function-map/weekport"),
        pathName: "功能地图周报",
    },
    {
        path: "/wChatMeetPeople",
        component: AsyncImport("weChat-meet-people"),
        pathName: "微信接人",
    },
    {
        path: "/rich-text",
        component: AsyncImport("rich-text"),
        pathName: "富文本编辑器",
    },
    {
        path: "/version-history",
        component: AsyncImport("version-history"),
        pathName: "版本历史",
    },
    {
        path: "/updateDesc/:type",
        component: AsyncImport("update-desc"),
        pathName: "App版本更新说明",
    },
    {
        path: "/vehicle-control/:carType(S01|T03)/:carInfo(electricity|EAndSpeed)",
        component: AsyncImport("vehicle-control"),
        pathName: "车辆控制",
        vehicleControl: true,
    },
    {
        path: "/oauth",
        component: AsyncImport("oAuth-demo"),
        pathName: "授权认证",
    },
    {
        path: "/oppo-oauth",
        component: AsyncImport("oppo-oauth"),
        pathName: "oppo授权认证",
    },
    // {
    //     path: '/token',
    //     component: AsyncImport('code-token'),
    //     pathName: '换取token'
    // },
    {
        path: "/vehicle-push",
        component: AsyncImport("vehicle-push"),
        pathName: "车机推送",
    },
    {
        path: "/blootooth-fault",
        component: AsyncImport("blootooth-fault"),
        pathName: "蓝牙无感钥匙说明与故障诊断",
    },
    {
        path: "/nfc-key-help",
        component: AsyncImport("nfc-key-help"),
        pathName: "NFC钥匙使用帮助",
    },
    {
        path: "/iccoa-classroom",
        component: AsyncImport("userbook"),
        pathName: "ICCOA用户手册",
    },
    {
        path: "/blootoothChargePoint",
        component: AsyncImport("blootooth-charge-point"),
        pathName: "蓝牙充电桩指引",
    },
    {
        path: "/disclaimer-share",
        component: AsyncImport("disclaimer-share"),
        pathName: "app免责声明",
    },
    {
        path: "/app/sliderCaptcha",
        component: AsyncImport("slider-captcha"),
        pathName: "app图形验证码",
    },
    {
        path: "/leapapp-protocol",
        component: AsyncImport("leapapp-protocol"),
        pathName: "app免责协议",
    },
    {
        path: "/cancellation-notice",
        component: AsyncImport("cancellation-notice"),
        pathName: "海外app注销须知",
    },
    {
        path: "/about-leapmotor",
        component: AsyncImport("about-leapmotor"),
        pathName: "海外app关于零跑",
    },
    {
        path: "/contact-us",
        component: AsyncImport("contact-us"),
        pathName: "海外app联系我们",
    },
    {
        path: "/user-agreement",
        component: AsyncImport("user-agreement"),
        pathName: "海外app用户协议",
    },
    {
        path: "/privacy-policy",
        component: AsyncImport("privacy-policy"),
        pathName: "海外app隐私政策",
    },
    {
        path: "/bluetooth-key-classroom",
        component: AsyncImport("bluetooth-key-classroom"),
        pathName: "海外app蓝牙钥匙小课堂",
    },
    {
        path: "/bind-charging-stations",
        component: AsyncImport("bind-charging-stations"),
        pathName: "海外app绑桩说明",
    },
    {
        path: "/delete-instructions",
        component: AsyncImport("delete-instructions"),
        pathName: "海外app删除说明",
    },
    {
        path: "/phone-assistance",
        component: AsyncImport("phone-assistance"),
        pathName: "海外app电话帮助",
    },
    {
        path: "/hk-contact-us",
        component: AsyncImport("hk-contact-us"),
        pathName: "香港app联系我们",
    },
    {
        path: "/hk-delete-instructions",
        component: AsyncImport("hk-delete-instructions"),
        pathName: "香港app删除说明",
    },
    {
        path: "/hk-privacy-policy",
        component: AsyncImport("hk-privacy-policy"),
        pathName: "香港app隐私政策",
    },
    ...messagePushTemplete, // 消息推送模板路由
    {
        path: "/app-ai-model/privacy",
        component: AsyncImport("app-ai-model/privacy"),
        pathName: "小零同学隐私政策",
    },
    {
        path: "/app-ai-model/agreement",
        component: AsyncImport("app-ai-model/agreement"),
        pathName: "小零同学服务须知",
    },
];

export default routes;
